import { Button } from "antd";

/** Properties to configure the footer. */
interface TakePaymentFooterProps {
    /** Function to execute when "Continue" is clicked. */
    readonly onContinue: () => Promise<void>;

    /** State indicating that buttons should show a loading indicator. */
    readonly isPending: boolean;
}

/** Footer for non-integrated take a payment flow, when a new P/RP is being provisioned manually. */
export const TakePaymentFooter = ({ onContinue, isPending }: TakePaymentFooterProps) => (
    <Button type="primary" htmlType="submit" value="continue" loading={isPending} onClick={() => void onContinue()}>
        Continue
    </Button>
);
